import * as amplitude from "@amplitude/analytics-browser";

// One narrow SDK boundary. Production delegates to Amplitude; unit tests replace
// these methods so the real analytics wrapper can run without network traffic.
export const analyticsSdk = {
  init: amplitude.init,
  add: amplitude.add,
  flush: amplitude.flush,
  setUserId: amplitude.setUserId,
  reset: amplitude.reset,
  identify: amplitude.identify,
  setGroup: amplitude.setGroup,
  groupIdentify: amplitude.groupIdentify,
  track: amplitude.track,
  newIdentify: () => new amplitude.Identify(),
};

export type EnrichmentPlugin = amplitude.Types.EnrichmentPlugin;
